import css from './index.module.scss';
import { LineSpace } from '@/components/ProductComponents';
import { TextOnImage, TextWithImage } from '@/components/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import NextImage from '@/components/NextImage';
import OtherList from '@/components/ProductCommon/OtherList';
import ProductRecommand from '@elem/compCommon/ProductRecomand';

const { EFPic } = createEFPic('/media/100W_flexible/pc/');

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_max'],
    cis: ['product_ps_delta_delta_pro', 'product_ps_delta_delta_max', 'product_ps_river_river_256'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    nl: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    mx: ['product_ps_river_703', 'product_ps_river_river_512', 'product_ps_river_river_768'],
    ph: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
};

export default function Content() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale = 'us' } = useRouter();
    const { t } = useLang('100wflexiblesolarpanel');
    const imgLocal = getImageLocal(locale, ['de', 'fr', 'jp', 'cis']);

    const getImgLocalSrc = () => {
        switch (locale) {
            case 'de':
                return {
                    webpSrc: require('@publicLocal/product/solar_panel_100w_flexible/pc/top_right_de.webp'),
                    src: require('@publicLocal/product/solar_panel_100w_flexible/pc/top_right_de.jpg'),
                };
            case 'fr':
                return {
                    webpSrc: require('@publicLocal/product/solar_panel_100w_flexible/pc/top_right_fr.webp'),
                    src: require('@publicLocal/product/solar_panel_100w_flexible/pc/top_right_fr.jpg'),
                };
            case 'jp':
                return {
                    webpSrc: require('@publicLocal/product/solar_panel_100w_flexible/pc/top_right_jp.webp'),
                    src: require('@publicLocal/product/solar_panel_100w_flexible/pc/top_right_jp.jpg'),
                };
            default:
                return {
                    webpSrc: require('@publicLocal/product/solar_panel_100w_flexible/pc/top_right_en.webp'),
                    src: require('@publicLocal/product/solar_panel_100w_flexible/pc/top_right_en.jpg'),
                };
        }
    };

    const webpUrl = '/media/100W_flexible/pc/';

    const textData3 = {
        img_url: '/product/solar_panel_100w_flexible/03.jpg',
        synopsis: t('solarpanels_100w_flexible.third_synopsis'),
        desc: t('solarpanels_100w_flexible.third_des'),
    };

    const textData4 = {
        title: t('solarpanels_100w_flexible.four_title'),
        synopsis: t('solarpanels_100w_flexible.four_synopsis'),
        desc: t('solarpanels_100w_flexible.four_des'),
        bgImgs: locale === 'cis' ? ['04_ru.webp', '04_ru.jpg'] : [`04_${imgLocal}.webp`, `04_${imgLocal}.jpg`],
    };

    const textData5 = {
        title: t('solarpanels_100w_flexible.five_title'),
        synopsis: t('solarpanels_100w_flexible.five_synopsis'),
        desc: t('solarpanels_100w_flexible.five_des'),
        bgImgs: ['05.webp', '05.jpg'],
    };

    const textData6 = {
        img_url: ['06.webp', '06.jpg'],
        title: t('solarpanels_100w_flexible.six_title'),
        synopsis: t('solarpanels_100w_flexible.six_synopsis'),
        desc: t('solarpanels_100w_flexible.six_des'),
    };

    const textData7 = {
        title: t('solarpanels_100w_flexible.seven_title'),
        synopsis: t('solarpanels_100w_flexible.seven_synopsis'),
        desc: t('solarpanels_100w_flexible.seven_des'),
        phrase: t('solarpanels_100w_flexible.seven_phrase'),
        bgImgs: ['07.webp', '07.jpg'],
    };

    const textData8 = {
        title: t('solarpanels_100w_flexible.eight_title'),
        synopsis: t('solarpanels_100w_flexible.eight_synopsis'),
        desc: t('solarpanels_100w_flexible.eight_des'),
        img_url: ['08.webp', '08.jpg'],
    };

    const textData9 = {
        img_url: ['6_drone.webp', '6_drone.jpg'],
        title: t('solarpanels_100w_flexible.nine_title'),
        synopsis: t('solarpanels_100w_flexible.nine_synopsis'),
        desc: t('solarpanels_100w_flexible.nine_des'),
    };

    const props = {
        more: `https://${locale}.ecoflow.com/pages/portable-power-stations`,
        data: [
            {
                productId: '9935710912788',
                variantId: '51194414924052',
            },
            {
                productId: '9935700132116',
                variantId: '51194378682644',
            },
            {
                productId: '9935714386196',
                variantId: '51427570286868',
            },
        ],
    };

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <LineSpace height={180} background="transparent" />
            <div className="banner-content">
                <div className="sec-top">
                    <div className="left section">
                        <div className="tit">{t('solarpanels_100w_flexible.second_light_weight')}</div>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solar_panel_100w_flexible/pc/top_left.webp')}
                                src={require('@publicLocal/product/solar_panel_100w_flexible/pc/top_left.jpg')}
                                className="fullImgs"
                                alt={t('solarpanels_100w_flexible.second_light_weight')}
                            />
                        </div>
                    </div>
                    <div className="right section">
                        <div className="tit">{t('solarpanels_100w_flexible.second_flexible_for')}</div>
                        <div className="bg-img">
                            {locale !== 'cis' && (
                                <NextImage
                                    webpSrc={getImgLocalSrc().webpSrc}
                                    src={getImgLocalSrc().src}
                                    className="fullImgs"
                                    alt={t('solarpanels_100w_flexible.second_flexible_for')}
                                />
                            )}
                            {locale === 'cis' && (
                                <EFPic
                                    name={['top_right_ru.webp', 'top_right_ru.jpg']}
                                    className="fullImgs"
                                    alt={t('solarpanels_100w_flexible.second_flexible_for')}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className="sec-bottom">
                    <div className="left section">
                        <div className="tit">
                            {locale === 'fr' ? (
                                <>
                                    <div className="text2">{t('solarpanels_100w_flexible.second_waterproof')}</div>
                                    <div className="text1">{t('solarpanels_100w_flexible.second_IP68')}</div>
                                </>
                            ) : (
                                <>
                                    <div className="text1">{t('solarpanels_100w_flexible.second_IP68')}</div>
                                    <div className="text2">{t('solarpanels_100w_flexible.second_waterproof')}</div>
                                </>
                            )}
                        </div>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solar_panel_100w_flexible/pc/bottom_left.webp')}
                                src={require('@publicLocal/product/solar_panel_100w_flexible/pc/bottom_left.jpg')}
                                className="fullImgs"
                                alt={t('solarpanels_100w_flexible.second_IP68')}
                            />
                        </div>
                    </div>
                    <div className="right section">
                        <div className="tit">{t('solarpanels_100w_flexible.second_universally')}</div>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solar_panel_100w_flexible/pc/bottom_right.webp')}
                                src={require('@publicLocal/product/solar_panel_100w_flexible/pc/bottom_right.jpg')}
                                className="fullImgs"
                                alt={t('solarpanels_100w_flexible.second_universally')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <LineSpace height={180} background="transparent" />
            <div className="textData3">
                <TextWithImage data={textData3} config={{ position: 'top' }} />
            </div>
            <LineSpace height={180} background="transparent" />
            <div className="container textData4">
                <TextOnImage data={textData4} config={{ position: 'left', webpUrl }} />
            </div>
            <LineSpace height={180} background="transparent" />
            <div className="container textData5">
                <TextOnImage data={textData5} config={{ position: 'right', webpUrl }} />
            </div>
            <LineSpace height={180} background="transparent" />
            <TextWithImage data={textData6} config={{ position: 'top', webpUrl }} />
            <LineSpace height={180} background="transparent" />
            <div className="container textData7">
                <TextOnImage data={textData7} config={{ position: 'right', webpUrl }} />
            </div>
            <div className="textData8">
                <LineSpace height={220} background="transparent" />
                <TextWithImage data={textData8} config={{ position: 'top', webpUrl }} />
                <div className="img-text text-left">{t('solarpanels_100w_flexible.eight_img_left')}</div>
                <div className="img-text text-right">{t('solarpanels_100w_flexible.eight_img_right')}</div>
            </div>
            <div className="textData9">
                <LineSpace height={220} background="transparent" />
                <TextWithImage data={textData9} config={{ position: 'top', webpUrl }} />
            </div>
            <div className="whatsBox">
                <LineSpace height={220} background="transparent" />
                <p className="title">{t('solarpanels_100w_flexible.ten_title')}</p>
                <div className="boxImg">
                    <div className="img">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solar_panel_100w_flexible/pc/09.webp')}
                            src={require('@publicLocal/product/solar_panel_100w_flexible/pc/09.png')}
                            className="fullImgs"
                            alt={t('solarpanels_100w_flexible.ten_title')}
                            aria-label={t('solarpanels_100w_flexible.ten_title')}
                        />
                    </div>
                    <p className="note">{t('solarpanels_100w_flexible.ten_note')}</p>
                </div>
            </div>
            <LineSpace height={280} background="transparent" />
            {['nl'].includes(locale) ? (
                <ProductRecommand {...props} />
            ) : (
                <OtherList
                    data={getDetaileMoreProducts(
                        gloproductlist,
                        product[locale] || product.us,
                        '',
                        '',
                        `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                    )}
                />
            )}
        </div>
    );
}
